import PropTypes from 'prop-types';
// import { Link } from '../../i18n'

const FooterColumn = ({ column }) => {
	return (
		<>
			<span>{column.title}</span>
			{column.elements && column.elements.length > 0 && column.elements.map((el, key) => (
				el.href.includes('https') || el.href.includes('mailto') ? (
					<a key={key} href={el.href} name={el.name}> {el.name} </a>
				) : (
				// <Link key={key} href={el.href}><a name={el.name}> {el.name} </a></Link>
					<a key={key} href={el.href} name={el.name}> {el.name} </a>
				)
			))}
		</>
	);
};

FooterColumn.propTypes = {
	column: PropTypes.object,
};

export default FooterColumn;
